import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {ModeDataService} from '../../editor-state/mode-data.service';
import {ClientEnvService} from '../../core/services/client-env.service';
import {TrainingsService} from '../../core/services/trainings.service';
import {AuthorisationService} from '../../core/services/authorisation.service';
import {AuthService} from '../../core/auth/auth.service';
import {ViewSourceService} from '../../shared/service/view-source.service';
import {DIAGRAM_VERSION_STATES_ENUM} from '../shared/models/diagram-version.constant';

export interface IToolbarMode {
  authorisationMode?: boolean;
  isStripped?: boolean;
  isTrainingMode?: boolean;
  canBeExpanded?: boolean;
  expanded?: boolean;
  showVote?: boolean;
  canEditDiagram?: boolean;
  editMode?: boolean;
  currentVote?: string;
  canCopyDiagram?: boolean;
  canRequestEditRights?: boolean;
}

@Injectable()
export class ToolbarStateService {
  private toolbarState: BehaviorSubject<IToolbarMode> = new BehaviorSubject({});
  toolbarState$: Observable<IToolbarMode> = this.toolbarState.asObservable();

  constructor(
    private modeDataSvc: ModeDataService,
    private clientEnvSvc: ClientEnvService,
    private viewSourceService: ViewSourceService,
    public trainingsService: TrainingsService,
    private authorisationService: AuthorisationService,
    public authSvc: AuthService
  ) {}

  public initiateToolbarState(diagramJson) {
    const isStripped = this.clientEnvSvc.isStripped;
    const canEditDiagram = this.authSvc.canEditDiagram();
    const canCopyDiagram = this.authSvc.getMapState() !== 'DELETED';
    const canRequestEditRights =
      diagramJson.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT &&
      this.authSvc.getMapState() !== 'DELETED' &&
      !this.authSvc.canEditDiagram();
    const canBeExpanded = !isStripped;
    const showThumb = this.showThumbsBtns(diagramJson);
    const editMode$ = this.modeDataSvc.currentMode$.pipe(map(obj => obj.edit));

    const trainingMode$ = this.trainingsService.trainingMode$;
    const authorisationMode$ = this.authorisationService.authorisationMode$;

    combineLatest(editMode$, trainingMode$, authorisationMode$)
      .pipe()
      .subscribe(([editModeVal, isTrainingMode, authorisationMode]) => {
        const availableToExpand =
          !isTrainingMode && !authorisationMode && canBeExpanded && !this.isInIframe();
        const expanded = availableToExpand || editModeVal || this.toolbarState.value.expanded;

        if (expanded) {
          this.clientEnvSvc.sidebarModuleSubject$.next(true);
        }

        this.toolbarState.next({
          isStripped,
          isTrainingMode,
          authorisationMode,
          canBeExpanded,
          canEditDiagram,
          showVote: showThumb,
          editMode: editModeVal && canEditDiagram,
          expanded: availableToExpand || editModeVal || this.toolbarState.value.expanded,
          canCopyDiagram,
          canRequestEditRights
        });
      });
  }
  public toogleExpanded() {
    this.toolbarState.next({
      ...this.toolbarState.value,
      expanded: !this.toolbarState.value.expanded
    });
  }

  private showThumbsBtns(diagramJson) {
    const isProPlus = !!diagramJson.team.plan.proPlus;
    const isMasterState = diagramJson.state === DIAGRAM_VERSION_STATES_ENUM.MASTER;

    return isProPlus && isMasterState;
  }

  private isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
